// extracted by mini-css-extract-plugin
module.exports = {"dot_separator":"_1ffo1UTp1mQN0b7qHURgll","Wrapper":"_2FvtgYoPCSImnFh277iE8x","Description":"MSACydE4PB5dNfTbUDyZP"};